import { Button, IconButton, Link } from "@mui/material"
import DrawIcon from '@mui/icons-material/Draw';
import { useContextWithGuard } from "../helpers/useContextWithGuard";
import { DeviceContext } from "../device/deviceProvider";
import { useAnalytics } from "../firebase/firebase";
import { IQuestion } from "../types";

interface ScribbleButtonProps {
    question: IQuestion;
}

const iconButtonStyle = {
    color: "#666 !important",
    transform: "translateY(6%)",
    "&:hover": { color: "#000 !important", cursor: "pointer" }
}

export const ScribbleButton = (props: ScribbleButtonProps) => {
    const { track } = useAnalytics();

    return (
        <IconButton
            title="scribble"
            aria-label="Example"
            sx={iconButtonStyle}
            color="secondary"
        >
            <Link
                href={
                    `${process.env.PUBLIC_URL}/whiteboard?coll=${props.question.collection.slice(0, -5)}&id=${props.question.id}`
                }
                onClick={(e: any) => {
                    e.stopPropagation();
                    track("item.scribble", { id: props.question.id, collection: props.question.collection });
                }}
                target="_blank"
                sx={{ color: "inherit" }}
            >
                <DrawIcon />
            </Link>
        </IconButton >
    )
}